import { useVirtualizer } from "@tanstack/react-virtual";
import React, { useRef } from "react";

const VirtualizedList = ({
	items,
	rowRenderer,
	className,
	labelledby,
	onMouseDown = () => {}
}) => {
	const parentRef = useRef(null);

	const count = items.length;
	const virtualizer = useVirtualizer({
		count,
		getScrollElement: () => parentRef.current,
		estimateSize: () => 10,
		useAnimationFrameWithResizeObserver: true // @see: https://tanstack.com/virtual/latest/docs/api/virtualizer#useanimationframewithresizeobserver
	});

	const virtualItems = virtualizer.getVirtualItems();

	return (
		// eslint-disable-next-line jsx-a11y/no-static-element-interactions
		<div
			ref={parentRef}
			onMouseDown={onMouseDown}
			className={className}
			aria-labelledby={labelledby}
		>
			<div
				style={{
					height: virtualizer.getTotalSize(),
					position: "relative"
				}}
			>
				<div
					style={{
						width: "100%",
						transform: `translateY(${virtualItems[0]?.start ?? 0}px)`
					}}
				>
					{virtualItems.map((virtualRow) => {
						const item = items[virtualRow.index];

						return (
							<div
								key={virtualRow.key}
								data-index={virtualRow.index}
								ref={virtualizer.measureElement}
							>
								{rowRenderer(item)}
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
};

export default VirtualizedList;
